// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext"; // Auth context
import { HelperOnboardingProvider } from "./context/HelperOnboardingContext";
import { CookieProvider } from "./context/CookieContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
const AppTree = (
  <BrowserRouter>
    <AuthProvider>
      <HelperOnboardingProvider>
        <CookieProvider>
          <App />
        </CookieProvider>
      </HelperOnboardingProvider>
    </AuthProvider>
  </BrowserRouter>
);

root.render(<React.StrictMode>{AppTree}</React.StrictMode>);

